import { useAction, useAtom } from '@reatom/npm-react';
import { Path } from '@trwl/shared/lib/router';
import {
  addRecentSearchAction,
  clearRecentSearchAction,
  recentSearchAtom,
  removeRecentSearchAction,
} from '@trwl/store';
import { serializeFilterToQuery } from '@trwl/store/filter/serializer';
import { ym } from '@trwl/util';
import { SearchResultRow } from '@trwl/widgets/nav/search-sidebar/components/SearchResultRow';
import { useRouter } from 'next/navigation';
import React, { useCallback } from 'react';

export const RecentSearch = ({
  onItemClick,
}: {
  onItemClick?: (path: string) => void;
}) => {
  const [recentSearch] = useAtom(recentSearchAtom);
  const clearRecentSearch = useAction(clearRecentSearchAction);
  const removeRecentSearch = useAction(removeRecentSearchAction);
  const addRecentSearch = useAction(addRecentSearchAction);
  const router = useRouter();

  const handleClick = useCallback(
    (query: string) => {
      const trimmedQuery = query?.trim();
      ym('search-product');

      const path = `${Path.CATALOG}?filter=${serializeFilterToQuery({
        keyword: trimmedQuery,
      })}`;
      onItemClick?.(path);
      router.push(path);
      if (trimmedQuery) addRecentSearch(trimmedQuery);
    },
    [addRecentSearch, onItemClick, router],
  );

  if (!recentSearch.length) return null;

  return (
    <div className={'w-full flex flex-col items-start gap-2'}>
      <div className={'w-full flex justify-between gap-2'}>
        <div>Недавние</div>
        <div
          className={'font-light text-zinc-700 underline cursor-pointer'}
          onClick={clearRecentSearch}
        >
          Очистить историю
        </div>
      </div>
      {recentSearch.map((item, index) => (
        <SearchResultRow
          key={item}
          onClick={() => handleClick(item)}
          onRemove={() => removeRecentSearch(index)}
        >
          {item}
        </SearchResultRow>
      ))}
    </div>
  );
};
